"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigNumberSchemaValidator = exports.bigNumberAdvancedOptions = exports.groupByType = exports.BigNumberGroupByValuesType = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
var BigNumberGroupByValuesType;
(function (BigNumberGroupByValuesType) {
    BigNumberGroupByValuesType["SUM"] = "sum";
    BigNumberGroupByValuesType["AVG"] = "avg";
    BigNumberGroupByValuesType["COUNT"] = "count";
    BigNumberGroupByValuesType["COUNTDISTINCT"] = "count distinct";
    BigNumberGroupByValuesType["MIN"] = "min";
    BigNumberGroupByValuesType["MAX"] = "max";
})(BigNumberGroupByValuesType = exports.BigNumberGroupByValuesType || (exports.BigNumberGroupByValuesType = {}));
exports.groupByType = zod_1.z.nativeEnum(BigNumberGroupByValuesType);
exports.bigNumberAdvancedOptions = zod_1.z.object({
    rounding: common_1.roundingOpts,
    group_by_type: exports.groupByType.optional(),
    prefix: zod_1.z.string().optional(),
    suffix: zod_1.z.string().optional(),
    fontColor: zod_1.z.string().optional(),
});
exports.bigNumberSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, zod_1.z.object({
    big_number_column_id: zod_1.z.string(),
    filter: common_1.widgetFilterValidator.optional(),
    advanced_opts: exports.bigNumberAdvancedOptions
        .default({
        rounding: common_1.DEFAULT_ROUNDING_OPTS,
    })
        .optional(),
}));
